import { BitrixVue } from 'ui.vue';

BitrixVue.component('ResultBlockTop', {
	data() {
		return {
			show: false,
			isChangeDoorNameShown: false,
            doorNameValue: this.doorName
		};
	},
	props: ['state', 'doorName', 'doorAvailability', 'basketId'],
	methods: {
		changeMenuVisability() {
			this.show = !this.show;
		},
		removeDoor() {
			this.$store.dispatch('removeFromBasket', this.basketId);
		},
		copyDoor() {
			this.$store.dispatch('setCopyDoor', this.basketId);
		},
		showChangeDoorName() {
            this.isChangeDoorNameShown = !this.isChangeDoorNameShown;
        },
		renameDoorName(doorName) {
            const params = {
                doorName: doorName,
                basketId: this.basketId
            }
			this.$store.dispatch('renameDoorName', params);
            this.showChangeDoorName()
		},
	},
	template: `
    <div class="result-block__top">
        <div class="result-block__top-left">
            <div class="result-block__name" v-if="!isChangeDoorNameShown">{{doorNameValue}}</div>
            <div class="result-block__rename" v-else>
                <input class="result-block__rename-input" type="text" v-model="doorNameValue">
                <button class="conform-change__doorname" @click="renameDoorName(doorNameValue)"></button>
            </div>
            <div v-if="doorAvailability===true" class="result-block__status status-available">В наличии</div>
            <div v-else class="result-block__status status-not-available">Под заказ</div>
        </div>
        <div class="result-block__menu">
            <div class="result-block__menu-btn" :class="{active:show}" @click="changeMenuVisability()">
                <span></span>
                <span></span>
                <span></span>
            </div>
            <transition name="fade">
                <div class="result-block__menu-dropdown" v-if="show">
                    <div class="result-block__menu-items">
                        <!--<div class="result-block__menu-item" @click="changeMenuVisability()">Редактировать дверь</div>
                        <div class="result-block__menu-item" @click="changeMenuVisability()" @click="showChangeDoorName">Переименовать</div>-->
                        <div class="result-block__menu-item" @click="changeMenuVisability()" @click="copyDoor">Копировать</div>
                        <div class="result-block__menu-item" @click="changeMenuVisability()" @click="removeDoor">Удалить</div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
`,
});
